<template>
    <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
               <div class="card">
                  <div class="card-header d-flex justify-content-between">
                     <div class="header-title">
                        <h4 class="card-title">Game List</h4>
                     </div>
                  </div>

                  <div class="card-body">
                     <div class="row justify-content-between">
                        <div class="col-10 col-sm-10 col-md-9">
                           <div id="user_list_datatable_info" class="dataTables_filter">
                              <form class="mr-3 position-relative row">
                                 <div class="form-group col-md-4">
                                    <label for="gameCode">Game Code:</label>
                                    <b-form-select v-model="search.gameCode" :options="gameCodes"></b-form-select>
                                 </div>

                                 <div class="form-group col-md-4">
                                    <label for="category">Category:</label>
                                    <b-form-select v-model="search.category" :options="categories"></b-form-select>
                                 </div>

                                 <div class="form-group col-md-4">
                                    <label for="volatility">Volatility:</label>
                                    <b-form-select v-model="search.volatility" :options="volatilities"></b-form-select>
                                 </div>
                              </form>
                           </div>
                        </div>
                        
                        <div class="d-flex flex-row-reverse align-items-center col-2 col-sm-2 col-md-3">
                           <b-button variant="outline-primary" class="mx-2 border-none d-flex align-items-center" v-on:click="redirectAdd" style="height: 46px!important">
                              <i class="las la-plus-square h4 m-0 p-0"></i>
                           </b-button>
                           
                           <b-button variant="primary" v-on:click="getData">
                              <i class="las la-search"></i>
                           </b-button>
                        </div>
                     </div>

                     <data-tables-server :data="games" :total="dataCount" @size-change="handleSizeChange" @current-page-change="handleCurrentChange" @sort-change="sortChange">
                        <el-table-column :index="indexMethod" type="index" label="No." width="50" align="center"></el-table-column>                        
                        <el-table-column prop="code" label="Code" sortable="custom" min-width="150" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.code}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="name" label="Name" sortable="custom" min-width="150" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.name}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="nameCN" label="CN Name" sortable="custom" min-width="150" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.nameCN != null">{{scope.row.nameCN}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <!-- <el-table-column prop="shortDesc" label="Short Desc." sortable="custom" min-width="150" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.shortDesc}}</span>
                           </template>
                        </el-table-column> -->
                        <!-- <el-table-column prop="longDesc" label="Long Desc." sortable="custom" min-width="150" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.longDesc}}</span>
                           </template>
                        </el-table-column> -->
                        <!-- <el-table-column prop="feature" label="Feature" sortable="custom" min-width="150" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.features}}</span>
                           </template>
                        </el-table-column> -->
                        <el-table-column prop="line" label="Line" sortable="custom" min-width="80" header-align="center" align="right">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.line != null">{{scope.row.line}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="category" label="Category" sortable="custom" min-width="120" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.category != null">{{scope.row.category}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="volatility" label="Volatility" sortable="custom" min-width="120" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.volatility != null">{{scope.row.volatility}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <!-- <el-table-column prop="tag" label="Tag" sortable="custom" min-width="150" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.tag}}</span>
                           </template>
                        </el-table-column> -->
                        <el-table-column prop="releaseDate" label="Release Date" sortable="custom" min-width="140" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.releaseDate != null">{{moment(scope.row.releaseDate).format('yyyy-MM-DD')}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="rtp" label="RTP" sortable="custom" min-width="100" header-align="center" align="right">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.rtp != null">{{scope.row.rtp}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="platform" label="Platform" sortable="custom" min-width="110" header-align="center" align="center">
                           <template scope="scope">
                              <span class="h5" v-if="scope.row.platform != null" v-html="getPlatform(scope.row.platform)"></span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="language" label="Language" sortable="custom" min-width="120" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.language != null">{{scope.row.language}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="maxMultiplier" label="Max. Multiplier" min-width="140" header-align="center" align="right">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.maxMultiplier != null">{{scope.row.maxMultiplier}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="reelsRows" label="Reels X Rows" min-width="120" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.reelsRows != null">{{scope.row.reelsRows}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="gameProvider" label="Game Prov." min-width="120" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.gameProvider != null">{{scope.row.gameProvider}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="action" label="Action" min-width="100" align="center">
                           <template scope="scope">
                              <a class="iq-bg-primary" href="javascript:void()" v-b-tooltip.top v-on:click="redirectEdit(scope.row.code)"><i class="ri-pencil-line mr-1"></i></a>
                              <a class="iq-bg-primary" href="javascript:void()" v-b-tooltip.top v-on:click="deleteRecord(scope.row.code)" ><i class="ri-delete-bin-line mr-1"></i></a>
                           </template>
                        </el-table-column>
                     </data-tables-server>
                  </div>
               </div>
            </div>
         </div>
      </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { DataTablesServer } from 'vue-data-tables';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import moment from 'moment';

locale.use(lang)

const config = require("../../../../../config");
const constants = require("../../../../constants/CommonConstants");

Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(DataTablesServer)
Vue.prototype.moment = moment

export default {
   name:'GameList',
   data() {
      return {
         games: [],
         dataCount: 0,
         currentPage: 1,
         pageSize: 20,
         search: {
            gameCode: null,
            category: null,
            volatility: null
         },
         order: {
            column: null,
            order: null
         },
         gameCodes: [
            { value: null, text: 'All'}
         ],
         categories: [
            { value: null, text: 'All'}
         ],
         volatilities: [
            { value: null, text: 'All'}
         ],
         delForm: {
            id:''
         }
      }
   },
   mounted: async function() {
      await this.getData();
      await this.getAllGames();

      this.categories = this.categories.concat(constants.category);
      this.volatilities = this.volatilities.concat(constants.volatility);
   },
   methods: {
      getData: async function() {
         try {
            const res = await axios.get(config.api.URL + '/api/games/get-all', {
               params: {
                  m: this.$route.meta.uid,
                  page: this.currentPage,
                  limit: this.pageSize,
                  gamecode: this.search.gameCode,
                  category: this.search.category,
                  volatility: this.search.volatility,
                  ordercolumn: this.order.column,
                  order: this.order.order
               }
            });
            this.games = res.data.data;
            this.dataCount = res.data.count;
         } catch(error) {
            alert("Error: Unable to retrieve data");
            console.log("Error: ", error)
         }
      },
      getAllGames: async function() {
         try {
            const res = await axios.get(config.api.URL + '/api/games/get-all', {
               params: {
                  m: this.$route.meta.uid
               }
            });

            let data = res.data.data;
            data.forEach(ele => {
               this.gameCodes.push({
                  value: ele.code,
                  text: ele.code
               });
            });
         } catch(error) {
            alert("Error: Unable to retrieve data");
            console.log("Error: ", error)
         }
      },
      redirectAdd: async function() {
         this.$router.push({path: '/games/add'});
      },
      redirectEdit: async function(code) {
         this.$router.push({path: '/games/edit/' + code});
      },
      deleteRecord: async function(code) {
         try {
            if(confirm("Are you sure you want to delete this record?")) {
               await axios.delete(config.api.URL + '/api/games/delete', { params: { id: code, m: this.$route.meta.uid } });

               this.getData();
               alert("Record deleted.");
            }
         } catch(error) {
            alert("Error: Delete game unsuccessful.");
            console.log(error);
         }
      },
      handleSizeChange: async function(val) {
         this.pageSize = val;
         await this.getData();
      },
      handleCurrentChange: async function(val) {
         this.currentPage = val;
         await this.getData();
      },
      sortChange: async function(sortProps) {
         this.order.column = sortProps.prop;
         this.order.order = sortProps.order;

         await this.getData();
      },
      indexMethod(index) {
         return (this.currentPage - 1) * this.pageSize + index + 1 
      },
      getPlatform(data) {
         var str = "";
         if(data != null) {
            data.forEach(pf => {
               let obj = constants.platform.find(o => o.value === pf);
               str += obj.icon;
            });
         }

         return str;
      }
   }
}
</script>